import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue')
  },
  {
    path: '/tool',
    name: 'tool',
    component: () => import(/* webpackChunkName: "home" */ '../views/ToolView.vue')
  },
  {
    path: '/deeper',
    name: 'deeper',
    component: () => import(/* webpackChunkName: "home" */ '../views/DeeperView.vue')
  },
  {
    path: '/clear',
    name: 'clear',
    component: () => import(/* webpackChunkName: "home" */ '../views/ClearView.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
